/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_TitleInputs */

const en_why_listening_compare_title = /** @type {(inputs: Why_Listening_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening vs. other apps`)
};

const es_why_listening_compare_title = /** @type {(inputs: Why_Listening_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening vs. otras apps`)
};

/**
* | output |
* | --- |
* | "Listening vs. other apps" |
*
* @param {Why_Listening_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_title = /** @type {((inputs?: Why_Listening_Compare_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_title(inputs)
	return en_why_listening_compare_title(inputs)
});